import type { ComponentStyleConfig } from "@chakra-ui/theme";

const PremiumCalcModal: ComponentStyleConfig = {
	baseStyle: {
		title: {
			textAlign: "center",
			pb: 10,
		},
		select: {
			maxWidth: "sm",
		},
		checkbox: {
			p: 0,
			fontWeight: "medium",
			color: "brand.blue",
		},
	},
};

export default PremiumCalcModal;
